import { render, staticRenderFns } from "./CoralsolOcorrenciasTable.vue?vue&type=template&id=2a5e90c4&"
import script from "./CoralsolOcorrenciasTable.vue?vue&type=script&lang=js&"
export * from "./CoralsolOcorrenciasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports